import { IAmountEvent, getAmountEvent } from 'nomst/Stores/Decision/Constants/amountEvent';
import { getPerformanceRatingEvent } from 'nomst/Stores/Decision/Constants/performanceRatingEvent';
import { AmountCode } from 'typings/enums';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import { getTeamNotifyManagersEvent } from 'nomst/Stores/Decision/Constants/teamNotifyManagersEvent';

export class EventStore {
    private readonly _amountEvents: IAmountEvent[];

    constructor() {
        this._amountEvents = [];
    }

    addAmountEvent(
        employeeSourceId: string,
        amountCode: AmountCode,
        amountCycleId: number,
        amountValue: number,
        affectWorkflow: boolean): void {
        const amountEvent = getAmountEvent(
            employeeSourceId,
            amountCode,
            amountCycleId,
            amountValue,
            affectWorkflow);

        this._amountEvents.push(amountEvent);
    }

    async emitPerformanceRatingEvent(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string,
        oldValue: string,
        newValue: string): Promise<void> {
        const performanceRatingEvent = getPerformanceRatingEvent(
            employeeSourceId,
            oldValue,
            newValue);

        await dataManagerFactory.getEventDataManager().sendPerformanceRatingEvent(
            masterAccountId,
            cycleId,
            employeeSourceId,
            performanceRatingEvent);
    }

    async emitAmountEvents(masterAccountId: string, cycleId: number): Promise<void> {
        const amountEvents = this._amountEvents.splice(0, this._amountEvents.length);
        await dataManagerFactory.getEventDataManager().sendEvents(
            masterAccountId,
            cycleId,
            amountEvents);
    }

    async emitNotifyManagersEvent(masterAccountId: string, cycleId: number, userId: string): Promise<void> {
        const teamNotifyManagersEvent = getTeamNotifyManagersEvent(cycleId, userId);
        await dataManagerFactory.getEventDataManager().sendNotifyManagersEvent(
            masterAccountId,
            cycleId,
            teamNotifyManagersEvent
        );
    }

    get hasAmountEvents(): boolean {
        return this._amountEvents && this._amountEvents.length > 0;
    }
}